import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import './HeroSection.css';
import languageMap from './languageMap';

function HeroSection() {
  const selectedLanguage = languageMap.config.selectedLanguage;
  const history = useHistory();

  const handleNavigate = (path) => {
    history.push(path);
  };

  return (
    <div className='hero-container blur-background blur-bottom blur-top' style={{
      "--circle-size": "200px",
      "--translate-x": "-10%",
      "--translate-y": "-30%",
    }}>
       <div className="top-main">
      <div className="logo-container-main">
        <img className="logo-container-img" src='/icons/logo.png' alt='Logo' />
      </div>
      </div>
      <div className="bottom-main">
      <div className="hero-title-container">
      <div className='hero-title'>ברוכים הבאים</div>
      <div className='hero-title'>לאפליקציית היי איי</div>
      <div className='hero-sub-title'>{languageMap.heroSubtitle2[selectedLanguage]}</div>
      </div>


      <div className='hero-btns'>
        <button
          className='circular-button middle-button open-btn'
          onClick={() => handleNavigate('/sign-up')}
          aria-label={languageMap.heroGetStarted[selectedLanguage]}
        >
          {languageMap.heroGetStarted[selectedLanguage]}
        </button>

        <button
          className='circular-button secondary-button middle-button open-btn'
          onClick={() => handleNavigate('/sign-in')}
          aria-label='התחבר'
        >
          התחבר
        </button>

        <Link to="/contact"
          className='circular-button middle-button wight-button open-btn'

        >
          צרו איתנו קשר ;)
        </Link>
      </div>
      </div>
    </div>
  );
}

export default HeroSection;
